import formComponent from '@/util/proto/formComponent'
import Info from './info'


//审核结果:1、成功;2、已拒绝,3、不达标
// 1 成功  2安装不通过 3车辆不达标 4其他原因拒绝

const rejectModal = {
  data() {
    return {
      state:{
        reviewResult:null,
        reviewDesc:null,
      }
    }
  },
  created(){
    
  },
  methods:{
    save(d){
      const { state } = this
      if( state.reviewReason === null){
        this.$Message.error('请选择拒绝原因')
      }else{
        this.$emit('ok' , { ...state  })
      }
    }
  },
  render(){
    const { loading } = this

    return (
      <div>
        <div class="modal-body">
          <div style="margin-bottom:24px;text-align:center;">
            <sl-select dict="stdInstallationRejectResult" type="radio" v-model={this.state.reviewResult} />
          </div>
          <Input type="textarea" placeholder="请描述细节" autosize={{ minRows: 2, maxRows: 6 }} v-model={this.state.reviewDesc} />
        </div>
        <div class="modal-footer">
          <Button on-click={this.save} type="primary">确定</Button>
        </div>
      </div>
    )
  }
}

export default {
  extends: formComponent ,

  props:{
    id:{
      default:''
    },
    data:null,
    enable:{
      default:true
    }
  },
  data() {
    return {
      loading:false,
      paths:[],
      currentData:{}
    }
  },
  created(){
    if( this.data ){
      this.currentData = this.data
    }else{
      this.$request.stdInstallation(this.id).then( resp => {
        this.currentData = resp.data
      })
    }
  },
  methods:{
    pass(data){

      const params = Object.assign( { id:this.id } , data || {})

      this.loading = true

      this.$request.stdInstallationReview(params).then(resp => {
        this.loading = false
        
        if(resp.code){
          this.$Message.error(resp.msg)
        }else{
          this.$Message.success('审核完成')
          this.$emit('ok')
        }
      })  
    },

    reject(){
      this.$dialog({
        title:'请选择拒绝原因',
        width:550,
        paddingless:true,
        render:(h)=>{
          return <rejectModal />
        },
        onOk:({ data })=>{
          this.pass( data )
        }
      })
    }
  },
  render(){
    const { loading } = this
    const data = this.currentData || {}
    const extra = []
    if( data.installType == 1){
      extra.push( <sl-detail-list-item title="IMEI">{data.imei}</sl-detail-list-item> )
      extra.push( <sl-detail-list-item title="车辆编号">{data.carNo}</sl-detail-list-item> )
    }else if( data.installType == 3 ){
      extra.push( <sl-detail-list-item title="车牌号">{data.licenseNo}</sl-detail-list-item> )
    }
    const footer = this.enable ? <div class="modal-footer">
          <Button  style="margin-right:8px;" on-click={this.reject} type="default">拒绝</Button>
          <Button loading={loading} on-click={() => this.pass({reviewResult:1})} type="primary">确定</Button>
        </div> : null
    return (
      <div>
        <div class="modal-body">
          <Info data={data} />
        </div>
        { footer }
      </div>
    )
  }
}